import VueI18n from 'vue-i18n'
import Vue from 'vue'
// app根组件
import App from './App.vue'
// 路由组件
import router from './router'
// elemeent-ui组件
import './plugins/element.js'
// 导入全局样式表
import './assets/css/global.css'
// 导入vue-table-with-tree-grid插件
import TreeTable from 'vue-table-with-tree-grid'

// 导入富文本编辑器
import VueQuillEditor from 'vue-quill-editor'
// require styles 导入富文本编辑器对应的样式
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'

// 导入NProgress包对应的JS和CSS
import NProgress from 'nprogress'
import 'nprogress/nprogress.css'

// 导入axios包,挂载至Vue的原型对象上
import axios from 'axios'
import store from  './store'
import qs from 'qs';

Vue.use(VueI18n);

axios.defaults.withCredentials=true
// 配置请求的根路径
axios.defaults.baseURL = '/api'

// 跨域格式处理
// axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';

// 在request拦截器中,展示进度条,NProgress.start()
// axios.interceptors.request.use(config => {
//   NProgress.start()
//   // config.headers.Authorization = window.sessionStorage.getItem('token')
//   // 在最后必须 ruturn config
//   return config
// })
// 在response拦截器中,隐藏进度条,NProgress.done()
// axios.interceptors.response.use(config => {
//   NProgress.done()
//   return config
// })
Vue.prototype.$http = axios

Vue.config.productionTip = false

Vue.component('tree-table', TreeTable)
// 将富文本编辑器，注册为全局可用的组件
Vue.use(VueQuillEditor)
// 年-月-日 时:分:秒
Vue.filter('dateFormat', function(originVal) {
  const dt = new Date(originVal * 1000)
  const y = dt.getFullYear()
  const m = (dt.getMonth() + 1 + '').padStart(2, '0')
  const d = (dt.getDate() + '').padStart(2, '0')
  const hh = (dt.getHours() + '').padStart(2, '0')
  const mm = (dt.getMinutes() + '').padStart(2, '0')
  const ss = (dt.getSeconds() + '').padStart(2, '0')

  return `${y}-${m}-${d} ${hh}:${mm}:${ss}`
})

Vue.prototype.$scrollTo = (x = 0, y = 0, type = 'smooth') => {
  window.scrollTo({
      top: x,
      left: y,
      behavior: type // 滚动行为：smooth平滑滚动，instant瞬间滚动，默认值auto，等同于instant
  })
}


// router.beforeEach  一般用来做一些进入页面的限制
// router.beforeEach((to, from, next) => {
//   console.log('上一个页面：', from)
//   console.log('下一个页面：', to)
//   const userToken = window.sessionStorage.getItem('token')
//   const role = window.sessionStorage.getItem('role')
//   // 判断该路由是否需要登录权限
//   if (to.meta.requireAuth) {
//     // 判断本地是否存在token，有则说明登录过
//     if (userToken) {
//         if (to.meta.roles.length !== 0) {
//           // 下一个页面的roles是否与当前token相等
//           for (var i = 0; i < to.meta.roles.length; i++) {
//               if (role === to.meta.roles[i]) {
//                 // 角色匹配已登录，正常进入to.meta.roles[i]页面
//                 next()
//                 break
//               } else if (i === to.meta.roles.length - 1){
//                 next({path: '/login'})
//               }
//           }
//         } else {
//           next()
//         }
//     } else {
//       next({path: '/login'})
//     }
//   } else {
//     next()
//   }
//   // 本地存在token，则不允许直接跳转到登录页面
//   if (to.fullPath === '/login') {
//     if (userToken) {
//       next({ path: from.fullPath })
//     } else {
//       next()
//     }
//   }
// })

const i18n = new VueI18n({
  locale : window.sessionStorage.getItem('language') || '1',
  messages: {
    '1': require('./lang/cn.json'),
    '2': require('./lang/ft.json'),
    '3': require('./lang/en.json'),
    '4': require('./lang/yn.json'),
    '5': require('./lang/ry.json'),
    '6': require('./lang/hy.json'),
  }
});
// new一个Vue实例
new Vue({
  i18n,
  // router挂载vue实例
  router,
  store,
  render: h => h(App)
}).$mount('#app')
